import { createContext } from 'react';
export var GuardContext = /*#__PURE__*/createContext([]);